import { SidePanel } from "@wix/design-system";
import classNames from "classnames";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { PANEL_HEADER_ID } from "./../consts.js";
import classes from "./panel-scss.js";
const Panel = ({ children, dataHook, ...props }) => {
  const { isMobile, environment, t } = useContext(RicosContext);
  return /* @__PURE__ */ React.createElement("div", { role: "dialog", "aria-modal": "true", "aria-labelledby": PANEL_HEADER_ID }, /* @__PURE__ */ React.createElement(
    SidePanel,
    {
      width: isMobile ? "100%" : 288,
      height: isMobile ? "100vh" : "fit-content",
      ...props,
      dataHook: classNames("floating-layout-root", dataHook),
      skin: "floating",
      className: classNames(classes.modal, { [classes.liveSite]: environment === "liveSite" }),
      closeButtonProps: {
        ariaLabel: t("Panel_CloseButton_AriaLabel"),
        ...props.closeButtonProps
      }
    },
    children
  ));
};
export {
  Panel
};
//# sourceMappingURL=panel.js.map
